import { useLayoutEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { updateActivity } from '../../db/api.js'
import Icon from '../../components/icons.jsx'
import ActivityDeadlinePicker from './ActivityDeadlinePicker.jsx'

export default function ActivityInlineField({ activity, field, members, label, onSaved, disabled }) {
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const lock = useRef(false)
  const trigger = useRef(null)
  const popup = useRef(null)
  const [position, setPosition] = useState({ top: 0, left: 0 })
  const owner = field === 'responsavel_id'
  const close = () => { if (!lock.current) { setOpen(false); trigger.current?.focus() } }
  useLayoutEffect(() => {
    if (!open) return
    const place = () => {
      const anchor = trigger.current?.getBoundingClientRect()
      if (!anchor || !popup.current) return
      const height = popup.current.offsetHeight
      const width = popup.current.offsetWidth
      setPosition({ left: Math.max(8, Math.min(anchor.left, window.innerWidth - width - 8)), top: Math.max(8, anchor.bottom + height + 8 <= window.innerHeight ? anchor.bottom + 6 : anchor.top - height - 6) })
    }
    const outside = event => {
      if (!popup.current?.contains(event.target) && !trigger.current?.contains(event.target) && !lock.current) setOpen(false)
    }
    place()
    const observer = new ResizeObserver(place)
    observer.observe(popup.current)
    document.addEventListener('pointerdown', outside)
    window.addEventListener('resize', place)
    window.addEventListener('scroll', place, true)
    return () => { observer.disconnect(); document.removeEventListener('pointerdown', outside); window.removeEventListener('resize', place); window.removeEventListener('scroll', place, true) }
  }, [open])
  const start = () => {
    let initial = activity[field] || ''
    if (!owner && initial) {
      const date = new Date(initial)
      const pad = n => String(n).padStart(2, '0')
      initial = Number.isNaN(date.getTime()) ? '' : `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
    }
    setValue(initial); setError(''); setOpen(true)
  }
  const save = async event => {
    event.preventDefault()
    if (lock.current) return
    lock.current = true; setSaving(true); setError('')
    try {
      await updateActivity(activity.id, { [field]: value ? owner ? value : new Date(value).toISOString() : null })
      await onSaved()
      setOpen(false)
    } catch (e) { setError(e.message) }
    finally { lock.current = false; setSaving(false) }
  }
  return <><button ref={trigger} type="button" className="dp-activity-inline-trigger" aria-expanded={open} aria-haspopup="dialog" disabled={disabled || saving} onClick={() => open ? close() : start()} title={owner ? 'Alterar responsável' : 'Alterar prazo'}><Icon n={owner ? 'user' : 'calendar'} s={13} />{label}</button>
  {open && createPortal(<form ref={popup} role="dialog" aria-label={owner ? 'Alterar responsável' : 'Alterar prazo'} className="dp-activity-inline-editor dp-activity-popover" style={position} onSubmit={save} onKeyDown={event => { if (event.key === 'Escape') { event.stopPropagation(); close() } }}>
    <strong className="dp-activity-popover-title">{owner ? 'Responsável' : 'Prazo da atividade'}</strong>
    {owner ? <div className="dp-activity-person-list">
      {[{ id: '', nome: 'Sem responsável' }, ...(activity.responsavel_id && !members.some(member => member.id === activity.responsavel_id) ? [{ id: activity.responsavel_id, nome: activity.responsavel_nome || 'Responsável atual' }] : []), ...members].map((member, index) => <button key={member.id} type="button" autoFocus={index === 0} aria-pressed={value === member.id} disabled={saving} onClick={() => setValue(member.id)}><span>{member.nome}</span>{value === member.id && <Icon n="check" s={14} />}</button>)}
    </div> : <ActivityDeadlinePicker value={value} onChange={setValue} disabled={saving} />}
    <footer><button type="button" disabled={saving} onClick={close}>Cancelar</button><button type="submit" disabled={saving}>{saving ? 'Salvando…' : 'Salvar'}</button></footer>
    {error && <p role="alert">{error}</p>}
  </form>, document.body)}</>
}
